import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "carlah_listing_view_mode";

export default class extends Controller {
  static targets = ["container", "gridBtn", "splitBtn", "announcer"];
  static values = { default: { type: String, default: "split" } };

  connect() {
    const savedMode = localStorage.getItem(STORAGE_KEY) || this.defaultValue;
    this.applyMode(savedMode, false);
  }

  setGrid() {
    this.applyMode("grid", true);
  }

  setSplit() {
    this.applyMode("split", true);
  }

  applyMode(mode, announce) {
    const isSplit = mode === "split";

    if (this.hasContainerTarget) {
      this.containerTarget.dataset.view = mode;
      if (isSplit) {
        this.containerTarget.classList.remove("lg:grid-cols-2");
        this.containerTarget.classList.add("grid-cols-1");
      } else {
        this.containerTarget.classList.remove("grid-cols-1");
        this.containerTarget.classList.add("lg:grid-cols-2");
      }
    }

    this.updateButtonStyles(this.gridBtnTarget, !isSplit);
    this.updateButtonStyles(this.splitBtnTarget, isSplit);

    localStorage.setItem(STORAGE_KEY, mode);

    // Force Swiper to recalculate slide dimensions after layout change
    window.dispatchEvent(new Event("resize"));

    if (announce && this.hasAnnouncerTarget) {
      this.announcerTarget.textContent = isSplit
        ? "Switched to split view with one card per row"
        : "Switched to grid view with two columns";
    }
  }

  updateButtonStyles(button, isActive) {
    if (!button) return;

    button.setAttribute("aria-pressed", isActive ? "true" : "false");

    if (isActive) {
      button.classList.add("bg-primary", "text-white", "border-primary", "z-10");
      button.classList.remove("bg-white", "text-gray-600", "border-gray-300", "hover:bg-gray-50", "hover:text-gray-900");
    } else {
      button.classList.remove("bg-primary", "text-white", "border-primary", "z-10");
      button.classList.add("bg-white", "text-gray-600", "border-gray-300", "hover:bg-gray-50", "hover:text-gray-900");
    }
  }
}
